import { render } from "./QuestionFormText.vue?vue&type=template&id=772e10ce&scoped=true&ts=true"
import script from "./QuestionFormText.vue?vue&type=script&lang=ts"
export * from "./QuestionFormText.vue?vue&type=script&lang=ts"

import "./QuestionFormText.vue?vue&type=style&index=0&id=772e10ce&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772e10ce"]])

export default __exports__